export default "/images/79f2ebc45f98a1da990173c403d262ec.avif";